module.exports = __webpack_public_path__ + "img/14-tatarak-bistro.ac247673.jpg";